import { PessoaFisica } from 'src/app/core/pessoa-fisica';
import { Component, OnInit, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { EnderecoService } from 'src/app/services/endereco/endereco.service';
import { DataUtilService } from 'src/app/services/commons/data-util.service';

@Component({
  selector: 'documentos-familiar-aluno',
  templateUrl: './documentos-familiar-aluno.component.html',
  styleUrls: ['./documentos-familiar-aluno.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class DocumentosFamiliarAlunoComponent implements OnInit {

  @Input() pessoaFisica: PessoaFisica;
  @Input() validaCPF: boolean = true;

  public mascaraCpf = [];
  public mascaraNIS = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, '-', /\d/];

  constructor(
    private enderecoService:EnderecoService,
    private dataUtilService: DataUtilService
  ) {
   }

  ngOnInit() {
    this.adicionarMascara();
  }


  adicionarMascara() {
    this.mascaraCpf = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/,];
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

  onUfCiChange(uf: any) {
    this.pessoaFisica.ufCi = uf?.nome;
  }

}
